import React from "react";
import { Box } from "@mui/material";
import { resolveMediaUrl } from "./ConfiguredWheelFace";

/** Offsets are pixels on a circle of this size, then scaled to the rendered size. */
export const PRIZE_CIRCLE_REF = 160;

export const prizeModalImageUrl = (entry) =>
  entry?.background_image_url || entry?.image_url || "";

const PrizeCircleImage = ({
  src = "",
  zoom = 1,
  rotation = 0,
  offsetX = 0,
  offsetY = 0,
  size = 96,
  ring = true,
}) => {
  const url = resolveMediaUrl(src);
  if (!url) return null;
  const scale = size / PRIZE_CIRCLE_REF;
  const fitted = Number(zoom) > 0 ? Number(zoom) : 1;
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        position: "relative",
        flexShrink: 0,
        bgcolor: "#111",
        border: ring ? "4px solid #FFD700" : "none",
        boxShadow: ring ? "0 0 24px rgba(255,215,0,0.5)" : "none",
      }}
    >
      <Box
        component="img"
        src={url}
        alt=""
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          width: size * fitted,
          height: size * fitted,
          objectFit: "cover",
          transform: `translate(-50%, -50%) translate(${Number(offsetX) * scale}px, ${Number(offsetY) * scale}px) rotate(${Number(rotation) || 0}deg)`,
          transformOrigin: "center center",
        }}
      />
    </Box>
  );
};

export default PrizeCircleImage;
